import { defineComponent as _defineComponent } from 'vue'
import { Lesson } from '~/types/resource';

interface Props {
  activeLesson?: number;
  lessons: Lesson[];
  layout?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LessonsList',
  props: {
    activeLesson: { default: 0 },
    lessons: null,
    layout: { default: 'basic' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})